import styled from 'styled-components';

import { baseColor, darkBaseColor, lightPrimaryColor } from 'views/services/color-scheme';
import backgroundImage from './assets/background-image.gif';

export const Background = styled.div`
  background-image: url(${backgroundImage});
  background-position: center top;
  height: 908px;
`;

export const Heading = styled.div`
  position: absolute;
  left: 47px;
  top: 42px;
`;

export const Table = styled.div`
  & > table {
    width: 399px;
    border-collapse: collapse;
    & > tbody {
      & > tr {
        & > th, & > td {
          font-weight: normal;
          text-align: left;
          vertical-align: top;
          padding: 3px 5px;
          border-right: 3px solid ${baseColor};
          border-bottom: 3px solid ${baseColor};
        }
        & > th {
          background-color: ${lightPrimaryColor};
        }
        & > td {
          background-color: ${darkBaseColor};
        }
      }
    }
  }
`;

export const Information = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 93px;
  }
  & > ${Table} {
    position: absolute;
    left: 44px;
    top: 139px;
  }
`;

export const Picture = styled.div`
  & > h2 {
    position: absolute;
    left: 502px;
    top: 93px;
  }
  & > img {
    position: absolute;
    left: 485px;
    top: 140px;
  }
`;

export const Message = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 616px;
  }
  & > div {
    position: absolute;
    left: 44px;
    top: 655px;
    & > ul {
      background-color: ${lightPrimaryColor};
      padding: 10px 10px 10px 0;
      width: 390px;
      font-size: 100%;
      font-weight: bold;
    }
    & > p:last-child {
      margin: 10px 0 0 300px;
    }
  }
`;

export const History = styled.div`
  & > h2 {
    position: absolute;
    left: 502px;
    top: 616px;
  }
  & > ${Table} {
    position: absolute;
    left: 484px;
    top: 655px;
  }
`;
